import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-parent-ai-disclaimer-banner',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './parent-ai-disclaimer-banner.component.html',
  styleUrl: './parent-ai-disclaimer-banner.component.scss',
})
export class ParentAiDisclaimerBannerComponent {}
